<div class="ball-pulse" [style]="'transform:scale(' + scale + ')'">
    <div [style]="'background:' + color"></div>
    &nbsp;
    <div [style]="'background:' + color"></div>
    &nbsp;
    <div [style]="'background:' + color"></div>
</div>